export default __webpack_public_path__ + "static/media/edot_cloudxier3.2d3574d8.png";